export const CLASS_NAME = 'cst-dropdown'
